import React from "react";
import { 
  Container, 
  Typography, 
  Grid, 
  Box, 
  Chip, 
  Divider, 
  Paper,
  Button,
  useTheme
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import VerifiedIcon from "@mui/icons-material/Verified";
import SchoolIcon from "@mui/icons-material/School";
import StarIcon from "@mui/icons-material/Star";
import pic from "../../assets/images/pic.png";

const DoctorProfilePage = () => {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          background: "linear-gradient(135deg, #1976d2 0%, #64b5f6 100%)",
          pt: 6,
          pb: 15,
          position: "relative",
          mb: -10,
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h4" sx={{ color: "white", fontWeight: 600, mb: 2 }}>
            Doctor Profile
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ position: "relative", mb: 6 }}>
        <Paper
          elevation={3}
          sx={{
            borderRadius: 4,
            overflow: "hidden",
          }}
        >
          {/* Profile Header Section */}
          <Box sx={{ p: { xs: 3, md: 5 }, display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: { xs: "center", md: "flex-start" } }}>
            <Box
              sx={{
                mr: { xs: 0, md: 5 },
                mb: { xs: 3, md: 0 },
                position: "relative",
              }}
            >
              <Box
                component="img"
                src={pic}
                alt="Dr. Sachin"
                sx={{
                  width: { xs: 200, md: 220 },
                  height: { xs: 200, md: 220 },
                  borderRadius: "16px",
                  border: "5px solid white",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: -10,
                  right: -10,
                  backgroundColor: "#4caf50",
                  color: "white",
                  borderRadius: "50%",
                  width: 40,
                  height: 40,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                }}
              >
                <VerifiedIcon />
              </Box>
            </Box>

            <Box sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}>
              <Typography variant="h3" fontWeight="700" gutterBottom>
                Dr. Sachin Harekare
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2, justifyContent: { xs: "center", md: "flex-start" } }}>
                <Chip 
                  icon={<StarIcon />} 
                  label="Cardiologist" 
                  color="primary" 
                  sx={{ fontWeight: 500, borderRadius: 2 }} 
                />
                <Chip 
                  label="10+ Years Experience" 
                  sx={{ borderRadius: 2, backgroundColor: "#e3f2fd", color: "#1976d2" }} 
                />
                <Chip 
                  label="Board Certified" 
                  sx={{ borderRadius: 2, backgroundColor: "#e8f5e9", color: "#388e3c" }} 
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2, mt: 3, justifyContent: { xs: "center", md: "flex-start" } }}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  startIcon={<CalendarMonthIcon />}
                  sx={{ borderRadius: 2, px: 3 }}
                >
                  Book Appointment
                </Button>
                <Button 
                  variant="outlined" 
                  color="primary"
                  sx={{ borderRadius: 2, px: 3 }}
                >
                  Send Message
                </Button>
              </Box>
            </Box>
          </Box>

          <Divider />

          {/* Contact Info */}
          <Box sx={{ p: { xs: 3, md: 4 }, backgroundColor: "#f9fafc" }}>
            <Typography variant="h5" fontWeight="600" gutterBottom sx={{ mb: 3, color: "#37474f" }}>
              Contact Information
            </Typography>
            
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", alignItems: "center", p: 2, bgcolor: "white", borderRadius: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                  <Box sx={{ bgcolor: "#e3f2fd", p: 1.5, borderRadius: 2, mr: 2 }}>
                    <PhoneIcon color="primary" />
                  </Box>
                  <Box>
                    <Typography variant="body2" color="text.secondary">Phone</Typography>
                    <Typography variant="body1" fontWeight="500">+91 8861551913</Typography>
                  </Box>
                </Box>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", alignItems: "center", p: 2, bgcolor: "white", borderRadius: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                  <Box sx={{ bgcolor: "#e3f2fd", p: 1.5, borderRadius: 2, mr: 2 }}>
                    <EmailIcon color="primary" />
                  </Box>
                  <Box>
                    <Typography variant="body2" color="text.secondary">Email</Typography>
                    <Typography variant="body1" fontWeight="500">Sachinharekare@gmail.com</Typography>
                  </Box>
                </Box>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", alignItems: "center", p: 2, bgcolor: "white", borderRadius: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                  <Box sx={{ bgcolor: "#e3f2fd", p: 1.5, borderRadius: 2, mr: 2 }}>
                    <LocationOnIcon color="primary" />
                  </Box>
                  <Box>
                    <Typography variant="body2" color="text.secondary">Location</Typography>
                    <Typography variant="body1" fontWeight="500">Puttur Karnataka</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Divider />

          {/* Biography Section */}
          <Box sx={{ p: { xs: 3, md: 5 } }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
              <SchoolIcon sx={{ mr: 2, color: "#1976d2" }} />
              <Typography variant="h5" fontWeight="600" color="#37474f">
                About Dr. Sachin Harekare
              </Typography>
            </Box>
            
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: "#546e7a" }}>
              Dr. Sachin is a board-certified Plastic, Aesthetic & Reconstructive surgeon. He is a dynamic surgeon with special interest in Aesthetic surgery.
            </Typography>
            
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: "#546e7a" }}>
              He has completed his training in Super microsurgery from the University of Tokyo, Japan. He was selected for the prestigious DAFPRS (Dutch Association of Facial Plastic & Reconstructive Surgeons) Fellowship in Rhinoplasty & Facial Aesthetics in Stuttgart, Germany. He has also undergone training in Breast Aesthetics & Body contouring in University Hospital Monclova in Madrid, Spain under Dr. Jorge Aso.
            </Typography>
            
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: "#546e7a" }}>
              Dr. Shetty has a special interest in body contouring after massive weight loss to help patients gain confidence to lead an active and fulfilling lifestyle. For the past few years, Dr. Shetty has also focused on rhinoplasty and facial rejuvenation. Other interests include Liposuction, Breast augmentation, reduction and Abdominoplasty (tummy tuck).
            </Typography>
            
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8, color: "#546e7a" }}>
              Dr. Shetty is also working to serve the public as an Assistant Professor in Plastic Surgery in Bangalore Medical College & Research center.
            </Typography>
            
            <Typography variant="body1" sx={{ lineHeight: 1.8, color: "#546e7a" }}>
              Socially, he is also the founding member of a nongovernment organization (NGO) called Anti-Pollution Drive to help collect data and aid in cleaning our environment.
            </Typography>
          </Box>

          {/* Education and Training */}
          <Divider />
          <Box sx={{ p: { xs: 3, md: 5 }, bgcolor: "#f9fafc" }}>
            <Typography variant="h5" fontWeight="600" gutterBottom sx={{ mb: 3, color: "#37474f" }}>
              Education & Training
            </Typography>
            
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Box sx={{ p: 3, bgcolor: "white", borderRadius: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", height: "100%" }}>
                  <Typography variant="h6" fontWeight="600" color="primary" gutterBottom>
                    University of Tokyo, Japan
                  </Typography>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    2015 - 2016
                  </Typography>
                  <Typography variant="body1">
                    Training in Super microsurgery
                  </Typography>
                </Box>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <Box sx={{ p: 3, bgcolor: "white", borderRadius: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", height: "100%" }}>
                  <Typography variant="h6" fontWeight="600" color="primary" gutterBottom>
                    DAFPRS Fellowship
                  </Typography>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    2017 - 2018
                  </Typography>
                  <Typography variant="body1">
                    Rhinoplasty & Facial Aesthetics - Stuttgart, Germany
                  </Typography>
                </Box>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <Box sx={{ p: 3, bgcolor: "white", borderRadius: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", height: "100%" }}>
                  <Typography variant="h6" fontWeight="600" color="primary" gutterBottom>
                    University Hospital Monclova
                  </Typography>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    2018 - 2019
                  </Typography>
                  <Typography variant="body1">
                    Training in Breast Aesthetics & Body Contouring - Madrid, Spain
                  </Typography>
                </Box>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <Box sx={{ p: 3, bgcolor: "white", borderRadius: 3, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", height: "100%" }}>
                  <Typography variant="h6" fontWeight="600" color="primary" gutterBottom>
                    Bangalore Medical College
                  </Typography>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    2019 - Present
                  </Typography>
                  <Typography variant="body1">
                    Assistant Professor in Plastic Surgery
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default DoctorProfilePage;
